import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import useAuthGuard from "../../Hooks/useAuthGuard";
import useAuthUserData from "../../Hooks/useAuthUserData";
import { registerScan, updateScanRegister } from "../../Services/scansService";
import { sendScanNotification } from "../../Services/notificationService";
import { useGetID, useSubscriber } from "./../../Hooks/useSuscribersService";
import { useLocation } from "react-router-dom";
import { FR_ROLE } from "../../utils/constants";
import AlertMessageQRScan from "../../components/AlertMessage/AlertMessageQRScan";
import HamburguerMenu from "../../components/HamburguerMenu";
import SummarizeDetails from "../../components/SummarizeDetails/SummarizeDetails";

const Summary: FC = () => {
  useAuthGuard({
    allowedRoles: [
      FR_ROLE.FIRST_RESPONDER_USER,
      FR_ROLE.FIRST_RESPONDER_ADMIN,
      FR_ROLE.FIRST_RESPONDER_OWNER,
    ],
  });

  const { user } = useAuthUserData();
  const navState = useLocation();
  const [isScanRegistered, setIsScanRegistered] = useState(false);

  // Get mmhid from route state instead of URL parameters
  const mmhId = navState.state?.mmhId;

  const { idSuscriber, loadUser } = useGetID(
    mmhId ? mmhId.toLowerCase().replaceAll("mmh", "") : ""
  );

  const { subscriber, loadingSuscriber } = useSubscriber(idSuscriber);
  console.log("🍉 ~ Summary ~ subscriber:", subscriber);

  useEffect(() => {
    const putScan = async () => {
      console.log("🍉 ~ putScan ~ idSuscriber:", idSuscriber);
      console.log("🍉 ~ putScan ~ user:", user);
      console.log("🍉 ~ putScan ~ isScanRegistered:", isScanRegistered);
      if (idSuscriber && user && !isScanRegistered) {
        try {
          if (navState?.state?.registerId) {
            await updateScanRegister(
              user?.id,
              navState?.state?.registerId,
              "Summary",
              navState?.state?.scanMethod ?? "MMHID"
            );
          } else {
            await registerScan(user?.id, {
              idSubscriber: idSuscriber,
              type: "Summary",
              method: navState?.state?.scanMethod ?? "MMHID",
            });
          }
          setIsScanRegistered(true);

          // Send email notification after successful scan registration
          try {
            await sendScanNotification({
              subscriberId: idSuscriber,
              scanMethod: navState?.state?.scanMethod ?? "MMHID",
            });
          } catch (notificationError) {
            console.error("Failed to send scan notification:", notificationError);
          }
        } catch (err) {
          console.error("Error registering scan:", err);
        }
      }
    };
    putScan();
  }, [idSuscriber, user]);

  if (loadUser || loadingSuscriber) return <div>Loading...</div>;

  if ( !idSuscriber ) {
    return (
      <div>
        <AlertMessageQRScan open={true} advice={"subscriberNotFound"} />
      </div>
    );
  }

  return (
    <Box>
      <HamburguerMenu />
      <Box>
        <SummarizeDetails idUser={idSuscriber} />
      </Box>
    </Box>
  );
};

export default Summary;
